import { render, staticRenderFns } from "./global-modals.vue?vue&type=template&id=8a97abec&"
import script from "./global-modals.vue?vue&type=script&lang=js&"
export * from "./global-modals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports